'use strict';

var MarketTDChartMarketsFilterFactory = function MarketTDChartMarketsFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketTDChartMarketsFilter() {
    DemandFilter.call(this, 'market', 'thematic-demand-chart-market-markets');
    this.registerFilters(injectedFilters);
  }
  MarketTDChartMarketsFilter.constructor = MarketTDChartMarketsFilter;
  MarketTDChartMarketsFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketTDChartMarketsFilter;
};
MarketTDChartMarketsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketTDChartMarketsFilterFactory;